import { render, staticRenderFns } from "./jy-outboundDetail.vue?vue&type=template&id=4dc6a44e&scoped=true&"
import script from "./jy-outboundDetail.vue?vue&type=script&lang=js&"
export * from "./jy-outboundDetail.vue?vue&type=script&lang=js&"
import style0 from "./jy-outboundDetail.vue?vue&type=style&index=0&id=4dc6a44e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc6a44e",
  null
  
)

export default component.exports